<template>
  <div class="person-info">
    <div class="person-title">{{ $t('personInfo.title') }}</div>
    <div class="table-center">
      <div class="table-btn">
        <el-row>
          <el-col :span="2">
            <el-button type="primary" @click="handleAddEdit()" :disabled="isTeamSubmitted">{{ $t('common.add') }}</el-button>
          </el-col>
          <el-col :span="4" v-if="showField('realNameChJson') || showField('realNameEnJson')">
            <el-input v-model="params.keyword" :placeholder="$t('common.pleaseInputKeyword')" style="width: 90%"></el-input>
          </el-col>
          <el-col :span="4" v-if="showField('genderJson')">
            <el-select v-model="params.gender" :placeholder="$t('common.pleaseSelect') + ' ' + $t('common.gender')" style="width: 90%" clearable filterable>
              <el-option v-for="item in genderList" :key="item.id" :label="item.nameCh" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4" v-if="showField('functionJson')">
            <el-select v-model="params.functionId" :placeholder="$t('common.pleaseSelect') + ' ' + $t('common.function')" style="width: 90%" clearable filterable>
              <el-option v-for="item in functionOptions" :key="item.id" :label="localeValue(item, functionNameKey)" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="findPersonList">{{ $t('common.search') }}</el-button>
            <el-button @click="emptyParams">{{ $t('common.reset') }}</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="table-body">
        <el-table :data="personList" :border="true" height="100%">
        <el-table-column type="index" :label="$t('common.serialNo')" width="50" :fixed="true"></el-table-column>
        <el-table-column prop="realNameCh" :label="labelField('realNameChJson')" min-width="150" :fixed="true" v-if="showField('realNameChJson')"></el-table-column>
        <el-table-column prop="realNameEn" :label="$t('personInfo.realNameEn')" min-width="150" v-if="showField('realNameEnJson')"></el-table-column>
        <el-table-column prop="familyNameCh" :label="$t('personInfo.surnameCh')" min-width="150" v-if="showField('familyNameChJson')"></el-table-column>
        <el-table-column prop="familyNameEn" :label="$t('personInfo.surnameEn')" min-width="150" v-if="showField('familyNameEnJson')"></el-table-column>
        <el-table-column prop="givenNameCh" :label="$t('personInfo.givenNameCh')" min-width="150" v-if="showField('givenNameChJson')"></el-table-column>
        <el-table-column prop="givenNameEn" :label="$t('personInfo.givenNameEn')" min-width="150" v-if="showField('givenNameEnJson')"></el-table-column>
        <el-table-column prop="certificateType" :label="$t('common.certificateType')" min-width="150" v-if="showField('certificateTypeJson')">
          <template slot-scope="scope">
            {{scope.row.certificateType === 1 ? $t('common.idCard') :
              scope.row.certificateType === 2 ? $t('common.drivingLicense') :
                  scope.row.certificateType === 3 ? $t('common.passport') :
                      scope.row.certificateType === 4 ? $t('common.militaryCard') :
                          scope.row.certificateType === 5 ? $t('common.hkMacauId') :
                              scope.row.certificateType === 6 ? $t('common.taiwanPermit') :
                                  scope.row.certificateType === 7 ? $t('common.other') : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="certificateNumber" :label="$t('common.certificateNumber')" min-width="150" v-if="showField('certificateNumberJson')"></el-table-column>
        <el-table-column prop="gender" :label="$t('common.gender')" min-width="150" v-if="showField('genderJson')">
          <template slot-scope="scope">
            {{scope.row.gender === 1 ? $t('common.male') : $t('common.female')}}
          </template>
        </el-table-column>
        <el-table-column prop="age" :label="$t('common.age')" min-width="150" v-if="showField('ageJson')"></el-table-column>
        <el-table-column prop="birthday" :label="$t('common.birthDate')" min-width="150" v-if="showField('birthdayJson')"></el-table-column>
        <el-table-column prop="groupNameCh" :label="$t('common.group')" min-width="150" v-if="showField('groupJson')">
          <template slot-scope="scope">
            {{localeValue(scope.row, competitionGroupNameKey)}}
          </template>
        </el-table-column>
          <el-table-column prop="itemNameCh" :label="$t('common.item')" min-width="150" v-if="showField('itemJson')">
          <template slot-scope="scope">
            {{localeValue(scope.row, competitionItemNameKey)}}
          </template>
        </el-table-column>
        <el-table-column prop="headIcon" :label="$t('common.headPhoto')" min-width="150" v-if="showField('headIconJson')">
          <template slot-scope="scope">
            <el-image style="width: auto; height: 60px"
                      :src="define.previewNginxUrl + scope.row.headIcon"
                      :preview-src-list="[define.previewNginxUrl + scope.row.headIcon]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="certificateFrontalPhoto" :label="$t('common.certificateFrontPhoto')" min-width="150" v-if="showField('certificateFrontalPhotoJson')">
          <template slot-scope="scope">
            <el-image style="width: auto; height: 60px"
                      :src="define.previewNginxUrl + scope.row.certificateFrontalPhoto"
                      :preview-src-list="[define.previewNginxUrl + scope.row.certificateFrontalPhoto]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="certificateReversePhoto" :label="$t('common.certificateBackPhoto')" min-width="150" v-if="showField('certificateReversePhotoJson')">
          <template slot-scope="scope">
            <el-image style="width: auto; height: 60px"
                      :src="define.previewNginxUrl + scope.row.certificateReversePhoto"
                      :preview-src-list="[define.previewNginxUrl + scope.row.certificateReversePhoto]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" :label="$t('common.contactPhone')" min-width="150" v-if="showField('mobileJson')"></el-table-column>
        <el-table-column prop="email" :label="$t('common.contactEmail')" min-width="150" v-if="showField('emailJson')"></el-table-column>
        <el-table-column prop="functionNameCh" :label="$t('common.function')" min-width="150" v-if="showField('functionJson')">
          <template slot-scope="scope">
            {{localeValue(scope.row, competitionFunctionNameKey)}}
          </template>
        </el-table-column>
        <el-table-column prop="customText1" :label="labelField('customText1Json')" min-width="150" v-if="showField('customText1Json')"></el-table-column>
        <el-table-column prop="customText2" :label="labelField('customText2Json')" min-width="150" v-if="showField('customText2Json')"></el-table-column>
        <el-table-column prop="customText3" :label="labelField('customText3Json')" min-width="150" v-if="showField('customText3Json')"></el-table-column>
        <el-table-column prop="customFile1" :label="labelField('customFile1Json')" min-width="150" v-if="showField('customFile1Json')">
          <template slot-scope="scope">
            <el-image style="width: auto; height: 60px"
                      :src="define.previewNginxUrl + scope.row.customFile1"
                      :preview-src-list="[define.previewNginxUrl + scope.row.customFile1]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="customFile2" :label="labelField('customFile2Json')" min-width="150" v-if="showField('customFile2Json')">
          <template slot-scope="scope">
            <el-image style="width: auto; height: 60px"
                      :src="define.previewNginxUrl + scope.row.customFile2"
                      :preview-src-list="[define.previewNginxUrl + scope.row.customFile2]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="customFile3" :label="labelField('customFile3Json')" min-width="150" v-if="showField('customFile3Json')">
          <template slot-scope="scope">
            <el-image style="width: auto; height: 60px"
                      :src="define.previewNginxUrl + scope.row.customFile3"
                      :preview-src-list="[define.previewNginxUrl + scope.row.customFile3]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('common.operation')" width="100">
          <template slot-scope="scope">
            <el-button @click="handleAddEdit(scope.row.id)" type="text" :disabled="isTeamSubmitted">{{ $t('common.edit') }}</el-button>
            <el-button @click="handleDelete(scope.row.id)" type="text" style="color:#F56C6C;" :disabled="isTeamSubmitted">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>

    <!--  添加  -->
    <el-dialog :title="!dataForm.id ? $t('personInfo.addOfficial') : $t('personInfo.editOfficial')" :visible.sync="formVisible" width="800px"
               lock-scroll :close-on-click-modal="false">
      <el-form ref="dataForm" :model="dataForm" :rules="ruleForm" v-loading="formLoading" label-width="150px">
        <el-form-item :label="labelField('realNameChJson')" :prop="requireField('realNameChJson') ? 'realNameCh' : ''" v-if="showField('realNameChJson')">
          <el-input v-model="dataForm.realNameCh" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('personInfo.realNameEn')" :prop="requireField('realNameEnJson') ? 'realNameEn' : ''" v-if="showField('realNameEnJson')">
          <el-input v-model="dataForm.realNameEn" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('personInfo.surnameCh')" :prop="requireField('familyNameChJson') ? 'familyNameCh' : ''" v-if="showField('familyNameChJson')">
          <el-input v-model="dataForm.familyNameCh" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('personInfo.surnameEn')" :prop="requireField('familyNameEnJson') ? 'familyNameEn' : ''" v-if="showField('familyNameEnJson')">
          <el-input v-model="dataForm.familyNameEn" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('personInfo.givenNameCh')" :prop="requireField('givenNameChJson') ? 'givenNameCh' : ''" v-if="showField('givenNameChJson')">
          <el-input v-model="dataForm.givenNameCh" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('personInfo.givenNameEn')" :prop="requireField('givenNameEnJson') ? 'givenNameEn' : ''" v-if="showField('givenNameEnJson')">
          <el-input v-model="dataForm.givenNameEn" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('common.certificateType')" :prop="requireField('certificateTypeJson') ? 'certificateType' : ''" v-if="showField('certificateTypeJson')">
          <el-select v-model="dataForm.certificateType" :placeholder="$t('common.pleaseSelect')" style="width: 100%">
            <el-option v-for="item in certificateTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.certificateNumber')" :prop="requireField('certificateNumberJson') ? 'certificateNumber' : ''" v-if="showField('certificateNumberJson')">
          <el-input v-model="dataForm.certificateNumber" :placeholder="$t('common.pleaseInput')" @blur="extractCertificateNumber" />
        </el-form-item>
        <el-form-item :label="$t('common.gender')" :prop="requireField('genderJson') ? 'genderName' : ''" v-if="showField('genderJson')">
          <el-input v-if="isFieldDisabled('genderJson')" v-model="dataForm.genderName" :placeholder="$t('common.autoGenerate')" disabled />
          <el-radio-group v-else v-model="dataForm.gender" @change="handleGenderChange">
            <el-radio v-for="item in genderList" :key="item.id" :label="item.id">{{ item.nameCh }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('common.age')" :prop="requireField('ageJson') ? 'age' : ''" v-if="showField('ageJson')">
          <el-input v-if="isFieldDisabled('ageJson')" v-model="dataForm.age" :placeholder="$t('common.autoGenerate')" disabled />
          <el-input-number v-else v-model="dataForm.age" :min="1" :max="150" controls-position="right" :placeholder="$t('common.pleaseInput')" style="width: 100%"/>
        </el-form-item>
        <el-form-item :label="$t('common.birthDate')" :prop="requireField('birthdayJson') ? 'birthday' : ''" v-if="showField('birthdayJson')">
          <el-input v-if="isFieldDisabled('birthdayJson')" v-model="dataForm.birthday" :placeholder="$t('common.autoGenerate')" disabled />
          <el-date-picker v-else v-model="dataForm.birthday" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.pleaseSelect')" style="width: 100%"/>
        </el-form-item>
        <el-form-item :label="$t('common.group')" :prop="requireField('groupJson') ? 'groupId' : ''" v-if="showField('groupJson')">
          <el-select v-model="dataForm.groupId" :placeholder="$t('common.pleaseSelect')" :disabled="isFieldDisabled('groupJson')" style="width: 100%">
            <el-option v-for="item in groupList" :key="item.id" :label="localeValue(item, groupNameKey)" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.item')" :prop="requireField('itemJson') ? 'itemId' : ''" v-if="showField('itemJson')">
          <el-select v-model="dataForm.itemId" :placeholder="$t('common.pleaseSelect')" :disabled="isFieldDisabled('itemJson')" style="width: 100%">
            <el-option v-for="item in itemList" :key="item.id" :label="localeValue(item, itemNameKey)" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.headPhoto')" :prop="requireField('headIconJson') ? 'headIcon' : ''" v-if="showField('headIconJson')">
          <el-upload class="image-uploader" :action="define.uploadUrl2 + 'images'" :headers="uploadHeaders"
                     :data="{fileName: uploadFileName('headIconJson'), competitionId: dataForm.competitionId}"
                     :show-file-list="false" :on-success="handleHeadIconSuccess"
                     :before-upload="beforeImageUpload" accept="image/*">
            <img v-if="dataForm.headIcon" :src="define.previewNginxUrl + dataForm.headIcon" class="image">
            <i v-else class="el-icon-plus image-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('common.certificateFrontPhoto')" :prop="requireField('certificateFrontalPhotoJson') ? 'certificateFrontalPhoto' : ''" v-if="showField('certificateFrontalPhotoJson')">
          <el-upload class="image-uploader" :action="define.uploadUrl2 + 'images'" :headers="uploadHeaders"
                     :data="{fileName: uploadFileName('certificateFrontalPhotoJson'), competitionId: dataForm.competitionId}"
                     :show-file-list="false" :on-success="handleCertificateFrontalPhotoSuccess"
                     :before-upload="beforeImageUpload" accept="image/*">
            <img v-if="dataForm.certificateFrontalPhoto" :src="define.previewNginxUrl + dataForm.certificateFrontalPhoto" class="image">
            <i v-else class="el-icon-plus image-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('common.certificateBackPhoto')" :prop="requireField('certificateReversePhotoJson') ? 'certificateReversePhoto' : ''" v-if="showField('certificateReversePhotoJson')">
          <el-upload class="image-uploader" :action="define.uploadUrl2 + 'images'" :headers="uploadHeaders"
                     :data="{fileName: uploadFileName('certificateReversePhotoJson'), competitionId: dataForm.competitionId}"
                     :show-file-list="false" :on-success="handleCertificateReversePhotoSuccess"
                     :before-upload="beforeImageUpload" accept="image/*">
            <img v-if="dataForm.certificateReversePhoto" :src="define.previewNginxUrl + dataForm.certificateReversePhoto" class="image">
            <i v-else class="el-icon-plus image-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('common.contactPhone')" :prop="requireField('mobileJson') ? 'mobile' : ''" v-if="showField('mobileJson')">
          <el-input v-model="dataForm.mobile" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('common.contactEmail')" :prop="requireField('emailJson') ? 'email' : ''" v-if="showField('emailJson')">
          <el-input v-model="dataForm.email" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="$t('common.function')" :prop="requireField('functionJson') ? 'functionId' : ''" v-if="showField('functionJson')">
          <el-select v-model="dataForm.functionId" :placeholder="$t('common.pleaseSelect')" style="width: 100%">
            <el-option v-for="item in functionOptions" :key="item.id" :label="localeValue(item, functionNameKey)" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="labelField('customText1Json')" :prop="requireField('customText1Json') ? 'customText1' : ''" v-if="showField('customText1Json')">
          <el-input v-model="dataForm.customText1" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="labelField('customText2Json')" :prop="requireField('customText2Json') ? 'customText2' : ''" v-if="showField('customText2Json')">
          <el-input v-model="dataForm.customText2" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="labelField('customText3Json')" :prop="requireField('customText3Json') ? 'customText3' : ''" v-if="showField('customText3Json')">
          <el-input v-model="dataForm.customText3" :placeholder="$t('common.pleaseInput')" />
        </el-form-item>
        <el-form-item :label="labelField('customFile1Json')" :prop="requireField('customFile1Json') ? 'customFile1' : ''" v-if="showField('customFile1Json')">
          <el-upload class="image-uploader" :action="define.uploadUrl2 + 'images'" :headers="uploadHeaders"
                     :data="{fileName: uploadFileName('customFile1Json'), competitionId: dataForm.competitionId}"
                     :show-file-list="false" :on-success="handleCustomFile1Success"
                     :before-upload="beforeImageUpload" accept="image/*">
            <img v-if="dataForm.customFile1" :src="define.previewNginxUrl + dataForm.customFile1" class="image">
            <i v-else class="el-icon-plus image-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item :label="labelField('customFile2Json')" :prop="requireField('customFile2Json') ? 'customFile2' : ''" v-if="showField('customFile2Json')">
          <el-upload class="image-uploader" :action="define.uploadUrl2 + 'images'" :headers="uploadHeaders"
                     :data="{fileName: uploadFileName('customFile2Json'), competitionId: dataForm.competitionId}"
                     :show-file-list="false" :on-success="handleCustomFile2Success"
                     :before-upload="beforeImageUpload" accept="image/*">
            <img v-if="dataForm.customFile2" :src="define.previewNginxUrl + dataForm.customFile2" class="image">
            <i v-else class="el-icon-plus image-uploader-icon"/>
          </el-upload>
        </el-form-item>
        <el-form-item :label="labelField('customFile3Json')" :prop="requireField('customFile3Json') ? 'customFile3' : ''" v-if="showField('customFile3Json')">
          <el-upload class="image-uploader" :action="define.uploadUrl2 + 'images'" :headers="uploadHeaders"
                     :data="{fileName: uploadFileName('customFile3Json'), competitionId: dataForm.competitionId}"
                     :show-file-list="false" :on-success="handleCustomFile3Success"
                     :before-upload="beforeImageUpload" accept="image/*">
            <img v-if="dataForm.customFile3" :src="define.previewNginxUrl + dataForm.customFile3" class="image">
            <i v-else class="el-icon-plus image-uploader-icon"/>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="btnLoading" @click="handleAddEditSubmit()">{{ $t('common.ok') }}</el-button>
    </span>
    </el-dialog>
  </div>
</template>
<script>
import {getPersonList, personEdit, getPersonInfo, personDel} from "@/api/person";
import {getCompetitionGroupList} from "@/api/competitionGroup";
import {getCompetitionItemList} from "@/api/competitionItem";
import {getFunctionList} from "@/api/function";
import {athleteCertificateDiscern} from "@/api/athlete";
import {compressImage} from "@/util/image";
export default {
  name: "person-info",
  props: {
    teamInfo: {
      type: Object,
      required: true
    },
    competitionFormConfigInfo: {
      type: Object,
      default: function () {
        return {
          id: '',
          competitionId: '',
          teamForm: {},
          athleteForm: {},
          personForm: {},
          summaryForm: {}
        }
      }
    }
  },
  computed: {
    // 是否显示字段
    showField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.personForm[fieldName];
        return fieldConfig && fieldConfig.isShow === 1;
      };
    },
    // 是否必填字段
    requireField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.personForm[fieldName];
        return fieldConfig && fieldConfig.isRequire;
      };
    },
    // 字段标签
    labelField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.personForm[fieldName];
        return fieldConfig && fieldConfig.label;
      };
    },
    // 是否验证字段
    validateField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.personForm[fieldName];
        return fieldConfig && fieldConfig.isValidate;
      };
    },
    // 多选选项字段
    checkedOptionsField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.personForm[fieldName];
        return fieldConfig && fieldConfig.checkedOptions;
      };
    },
    // 是否禁用字段（禁用时报名端不可编辑，仅当配置明确为false时开放编辑）
    isFieldDisabled() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.personForm[fieldName];
        return !(fieldConfig && fieldConfig.isDisabled === false);
      };
    },
    // 证件类型中英文
    certificateTypeOptions() {
      const certificateType = this.checkedOptionsField('certificateTypeJson');
      if (!certificateType) return [];
      const labelMap = {
        1: 'common.idCard',
        2: 'common.drivingLicense',
        3: 'common.passport',
        4: 'common.militaryCard',
        5: 'common.hkMacauId',
        6: 'common.taiwanPermit',
        7: 'common.other'
      };
      const options = certificateType.map((item) => {
        const value = Number(item);
        return { value, label: this.$t(labelMap[value] || '') };
      });
      options.sort((a, b) => a.value - b.value);
      return options;
    },
    // 性别中英文
    genderList() {
      return [
        { id: 1, nameCh: this.$t('common.male') },
        { id: 2, nameCh: this.$t('common.female') },
      ];
    },
    // 组别名称中英文
    groupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事组别名称中英文
    competitionGroupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'groupNameCh' : 'groupNameEn';
    },
    // 职能名称中英文
    functionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 赛事职能名称中英文
    competitionFunctionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'functionNameCh' : 'functionNameEn';
    },
    // 小项名称中英文
    itemNameKey() {
      return this.$i18n.locale === 'en' ? 'nameEn' : 'nameCh'
    },
    // 赛事小项名称中英文
    competitionItemNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemNameCh' : 'itemNameEn';
    },
    // 职能选项（按表单配置functionJson的checkedOptions过滤，未配置或为空时显示全部）
    functionOptions() {
      const fieldConfig = this.competitionFormConfigInfo.personForm.functionJson;
      const checkedOptions = fieldConfig && fieldConfig.checkedOptions;
      if (!checkedOptions || checkedOptions.length === 0) {
        return this.allFunctionOptions;
      }
      const ids = checkedOptions.map(item => Number(item));
      return this.allFunctionOptions.filter(item => ids.includes(item.id));
    },
    // 表单验证规则
    ruleForm() {
      const rules = {};
      // 姓名（中文）
      if (this.showField('realNameChJson')) {
        const realNameChRules = [];
        if (this.requireField('realNameChJson')) {
          realNameChRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (realNameChRules.length > 0) {
          rules.realNameCh = realNameChRules;
        }
      }
      // 姓名（英文）
      if (this.showField('realNameEnJson')) {
        const realNameEnRules = [];
        if (this.requireField('realNameEnJson')) {
          realNameEnRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (realNameEnRules.length > 0) {
          rules.realNameEn = realNameEnRules;
        }
      }
      // 姓氏（中文）
      if (this.showField('familyNameChJson')) {
        const familyNameChRules = [];
        if (this.requireField('familyNameChJson')) {
          familyNameChRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (familyNameChRules.length > 0) {
          rules.familyNameCh = familyNameChRules;
        }
      }
      // 姓氏（英文）
      if (this.showField('familyNameEnJson')) {
        const familyNameEnRules = [];
        if (this.requireField('familyNameEnJson')) {
          familyNameEnRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (familyNameEnRules.length > 0) {
          rules.familyNameEn = familyNameEnRules;
        }
      }
      // 名字（中文）
      if (this.showField('givenNameChJson')) {
        const givenNameChRules = [];
        if (this.requireField('givenNameChJson')) {
          givenNameChRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (givenNameChRules.length > 0) {
          rules.givenNameCh = givenNameChRules;
        }
      }
      // 名字（英文）
      if (this.showField('givenNameEnJson')) {
        const givenNameEnRules = [];
        if (this.requireField('givenNameEnJson')) {
          givenNameEnRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (givenNameEnRules.length > 0) {
          rules.givenNameEn = givenNameEnRules;
        }
      }
      // 证件类型
      if (this.showField('certificateTypeJson')) {
        const certificateTypeRules = [];
        if (this.requireField('certificateTypeJson')) {
          certificateTypeRules.push({required: true, message: this.$t('validate.requiredSelect'), trigger: "blur"});
        }
        if (certificateTypeRules.length > 0) {
          rules.certificateType = certificateTypeRules;
        }
      }
      // 证件号码
      if (this.showField('certificateNumberJson')) {
        const certificateNumberRules = [];
        if (this.requireField('certificateNumberJson')) {
          certificateNumberRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        // 验证证件号码
        if (this.dataForm.certificateType === 1) {
          certificateNumberRules.push({
            pattern: /(^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
            message: this.$t('validate.formatIncorrect'),
            trigger: 'blur'
          });
        }
        if (certificateNumberRules.length > 0) {
          rules.certificateNumber = certificateNumberRules;
        }
      }
      // 性别
      if (this.showField('genderJson')) {
        const genderNameRules = [];
        if (this.requireField('genderJson')) {
          genderNameRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (genderNameRules.length > 0) {
          rules.genderName = genderNameRules;
        }
      }
      // 组别
      if (this.showField('groupJson')) {
        const groupIdRules = [];
        if (this.requireField('groupJson')) {
          groupIdRules.push({required: true, message: this.$t('validate.requiredSelect'), trigger: "change"});
        }
        if (groupIdRules.length > 0) {
          rules.groupId = groupIdRules;
        }
      }
      // 小项
      if (this.showField('itemJson')) {
        const itemIdRules = [];
        if (this.requireField('itemJson')) {
          itemIdRules.push({required: true, message: this.$t('validate.requiredSelect'), trigger: "change"});
        }
        if (itemIdRules.length > 0) {
          rules.itemId = itemIdRules;
        }
      }
      // 大头照
      if (this.showField('headIconJson')) {
        const headIconRules = [];
        if (this.requireField('headIconJson')) {
          headIconRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (headIconRules.length > 0) {
          rules.headIcon = headIconRules;
        }
      }
      // 证件正面照
      if (this.showField('certificateFrontalPhotoJson')) {
        const certificateFrontalPhotoRules = [];
        if (this.requireField('certificateFrontalPhotoJson')) {
          certificateFrontalPhotoRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (certificateFrontalPhotoRules.length > 0) {
          rules.certificateFrontalPhoto = certificateFrontalPhotoRules;
        }
      }
      // 证件反面照
      if (this.showField('certificateReversePhotoJson')) {
        const certificateReversePhotoRules = [];
        if (this.requireField('certificateReversePhotoJson')) {
          certificateReversePhotoRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (certificateReversePhotoRules.length > 0) {
          rules.certificateReversePhoto = certificateReversePhotoRules;
        }
      }
      // 联系电话
      if (this.showField('mobileJson')) {
        const mobileRules = [];
        if (this.requireField('mobileJson')) {
          mobileRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        // 验证手机号格式
        if (this.validateField('mobileJson')) {
          mobileRules.push({
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t('validate.formatIncorrect'),
            trigger: "blur"
          });
        }
        if (mobileRules.length > 0) {
          rules.mobile = mobileRules;
        }
      }
      // 联系邮箱
      if (this.showField('emailJson')) {
        const emailRules = [];
        if (this.requireField('emailJson')) {
          emailRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        // 验证邮箱格式
        if (this.validateField('emailJson')) {
          emailRules.push({
            type: 'email',
            message: this.$t('validate.formatIncorrect'),
            trigger: "blur"
          });
        }
        if (emailRules.length > 0) {
          rules.email = emailRules;
        }
      }
      // 职能
      if (this.showField('functionJson')) {
        const functionIdRules = [];
        if (this.requireField('functionJson')) {
          functionIdRules.push({required: true, message: this.$t('validate.requiredSelect'), trigger: "blur"});
        }
        if (functionIdRules.length > 0) {
          rules.functionId = functionIdRules;
        }
      }
      // 自定义文本1
      if (this.showField('customText1Json')) {
        const customText1Rules = [];
        if (this.requireField('customText1Json')) {
          customText1Rules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (customText1Rules.length > 0) {
          rules.customText1 = customText1Rules;
        }
      }
      // 自定义文本2
      if (this.showField('customText2Json')) {
        const customText2Rules = [];
        if (this.requireField('customText2Json')) {
          customText2Rules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (customText2Rules.length > 0) {
          rules.customText2 = customText2Rules;
        }
      }
      // 自定义文本3
      if (this.showField('customText3Json')) {
        const customText3Rules = [];
        if (this.requireField('customText3Json')) {
          customText3Rules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (customText3Rules.length > 0) {
          rules.customText3 = customText3Rules;
        }
      }
      // 自定义文件上传1
      if (this.showField('customFile1Json')) {
        const customFile1Rules = [];
        if (this.requireField('customFile1Json')) {
          customFile1Rules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (customFile1Rules.length > 0) {
          rules.customFile1 = customFile1Rules;
        }
      }
      // 自定义文件上传2
      if (this.showField('customFile2Json')) {
        const customFile2Rules = [];
        if (this.requireField('customFile2Json')) {
          customFile2Rules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (customFile2Rules.length > 0) {
          rules.customFile2 = customFile2Rules;
        }
      }
      // 自定义文件上传3
      if (this.showField('customFile3Json')) {
        const customFile3Rules = [];
        if (this.requireField('customFile3Json')) {
          customFile3Rules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (customFile3Rules.length > 0) {
          rules.customFile3 = customFile3Rules;
        }
      }
      return rules;
    }
  },
  data() {
    return {
      // 文件上传token
      uploadHeaders: { Authorization: localStorage.getItem("token") },
      // 随队官员列表
      personList: [],
      // 查询条件
      params: {
        competitionId: '',
        realNameCh: '',
        gender: '',
        groupId: '',
        certificateNumber: '',
        functionId: '',
        keyword: ''
      },
      // 添加/修改表单
      formVisible: false,
      // 添加/修改表单加载loading
      formLoading: false,
      // 添加/修改表单确定loading
      btnLoading: false,
      // 表单数据
      dataForm: {
        id: '',
        competitionId: '',
        teamId: '',
        userId: '',
        realNameCh: '',
        realNameEn: '',
        familyNameCh: '',
        familyNameEn: '',
        givenNameCh: '',
        givenNameEn: '',
        gender: '',
        genderName: '',
        age: '',
        birthday: '',
        groupId: '',
        itemId: '',
        headIcon: '',
        certificateType: 1,
        certificateNumber: '',
        certificateFrontalPhoto: '',
        certificateReversePhoto: '',
        mobile: '',
        email: '',
        functionId: '',
        customText1: '',
        customText2: '',
        customText3: '',
        customFile1: '',
        customFile2: '',
        customFile3: '',
      },
      // 组别列表
      groupList: [],
      // 小项列表
      itemList: [],
      // 人员职能（全量，展示时按表单配置过滤）
      allFunctionOptions: [],
    };
  },
  created() {
    // 记录表单初始结构，新增时整体重置，避免上一次编辑的遗留值（如性别单选框）
    this.initDataForm = JSON.parse(JSON.stringify(this.dataForm));
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.params.competitionId = id;
    }
  },
  mounted() {
    // 如果只有一个证件类型选项，自动选中
    if (this.certificateTypeOptions.length === 1) {
      this.dataForm.certificateType = this.certificateTypeOptions[0].value;
    }
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.params.competitionId });
    } else {
      this.findPersonList();
      this.findFunctionList();
      this.findCompetitionGroupList();
      // 小项选项（按当前赛事与小项级别配置）
      const itemLevel = ((this.competitionFormConfigInfo.personForm || {}).itemJson || {}).groupLevel;
      getCompetitionItemList({competitionId: this.params.competitionId, level: itemLevel || ''}).then((res) => {
        if (res.code === 200) {
          this.itemList = res.data.list;
        }
      });
    }
  },
  destroyed() {

  },
  methods: {
    // 随队官员列表
    findPersonList(){
      getPersonList(this.params).then((res) => {
        if (res.code === 200) {
          this.personList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 添加/修改表单
    handleAddEdit(id){
      this.dataForm.id = id || '';
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields();
        if (id) {
          getPersonInfo(id).then((res) => {
            if (res.code === 200) {
              let dataForm = res.data;
              dataForm.genderName = dataForm.gender === 1 ? this.$t('common.male') : this.$t('common.female');
              this.dataForm = dataForm;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          // 新增：整体重置为初始结构（resetFields只重置配置了prop的字段）
          this.dataForm = JSON.parse(JSON.stringify(this.initDataForm));
          this.dataForm.competitionId = this.params.competitionId;
        }
      })
    },
    // 组别列表（按表单配置的组别级别过滤：1-一级组别，2-二级组别，空-全部）
    findCompetitionGroupList(){
      const groupLevel = (this.competitionFormConfigInfo.personForm || {}).groupJson ? this.competitionFormConfigInfo.personForm.groupJson.groupLevel : '';
      getCompetitionGroupList({competitionId: this.params.competitionId, level: groupLevel || ''}).then((res) => {
        if (res.code === 200) {
          this.groupList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 上传文件名：队伍名称_随队官员_字段名称(表单配置label)_运动员姓名_证件号（label为空时回退字段标识）
    uploadFileName(configKey) {
      const fieldConfig = (this.competitionFormConfigInfo.personForm || {})[configKey] || {};
      const parts = [
        this.teamInfo.teamName,
        '随队官员',
        fieldConfig.label || configKey,
        this.dataForm.realNameCh || this.dataForm.realNameEn || '',
        (this.dataForm.certificateNumber || '').trim()
      ].filter(part => part);
      return parts.join('_');
    },
    beforeImageUpload(file){
      if (!this.dataForm.certificateNumber) {
        this.$message.error(this.$t('personInfo.needCertNumber'));
        return false;
      }
      // 压缩至200KB以内后替换原文件上传
      return compressImage(file);
    },
    // 大头照上传回调
    handleHeadIconSuccess(res) {
      if (res.code === 200) {
        this.dataForm.headIcon = res.data.url;
        if (this.requireField('headIconJson')) {
          this.$refs['dataForm'].validateField('headIcon');
        }
      } else {
        this.$message.error(this.$t('personInfo.photoUploadFailed'));
      }
    },
    // 性别切换（可编辑模式下同步性别名称，供校验与展示）
    handleGenderChange(value) {
      const item = this.genderList.find(item => item.id === value);
      this.dataForm.genderName = item ? item.nameCh : '';
    },
    // 身份证性别、年龄、出生日期
    extractCertificateNumber() {
      let certificateNumber = this.dataForm.certificateNumber.trim();
      if (certificateNumber.length === 18) {
        athleteCertificateDiscern({
          certificateType: 1,
          certificateNumber: certificateNumber
        }).then((res) => {
          if (res.code === 200) {
            let sysAthleteCertificateDiscernVo = res.data;
            let certificateDiscern = this.checkedOptionsField('certificateDiscernJson');
            // 未配置身份证内容识别时不做自动填充与清空
            if (!certificateDiscern) {
              return;
            }
            // 出生日期
            if (certificateDiscern.includes('3')) {
              this.dataForm.birthday = sysAthleteCertificateDiscernVo.birthday;
            } else {
              this.dataForm.birthday = '';
            }

            // 性别(17位奇数为男，偶数为女)
            if (certificateDiscern.includes('1')) {
              this.dataForm.genderName = sysAthleteCertificateDiscernVo.genderName;
              this.dataForm.gender = sysAthleteCertificateDiscernVo.gender;
            } else {
              this.dataForm.genderName = '';
              this.dataForm.gender = '';
            }

            // 年龄计算
            if (certificateDiscern.includes('2')) {
              this.dataForm.age = sysAthleteCertificateDiscernVo.age;
            } else {
              this.dataForm.age = '';
            }

            // 识别组别
            if (certificateDiscern.includes('4')) {
              const birthDate = sysAthleteCertificateDiscernVo.birthday;
              let age = sysAthleteCertificateDiscernVo.age;
              const gender = sysAthleteCertificateDiscernVo.gender;
              let groupRadioValue = this.radioValueField('groupJson');
              let groupObj = {}
              if (groupRadioValue === 1) {
                groupObj = this.groupList.find(item => item.gender === gender && age >= item.ageStartValue && age <= item.ageEndValue)
              }
              if (groupRadioValue === 2) {
                groupObj = this.groupList.find(item => item.gender === gender && birthDate >= new Date(item.birthdayStartValue) && birthDate <= new Date(item.birthdayEndValue))
              }
              if (groupObj) {
                this.dataForm.groupId = groupObj.id;
              } else {
                this.dataForm.groupId = '';
                this.findCompetitionGroupList(this.dataForm.gender);
              }
            } else {
              this.dataForm.groupId = '';
            }
            // 识别回填后重新校验相关字段（清除残留提示）
            if (this.requireField('genderJson')) {
              this.$refs['dataForm'].validateField('genderName');
            }
            if (this.requireField('ageJson')) {
              this.$refs['dataForm'].validateField('age');
            }
            if (this.requireField('birthdayJson')) {
              this.$refs['dataForm'].validateField('birthday');
            }
            if (this.requireField('groupJson')) {
              this.$refs['dataForm'].validateField('groupId');
            }
          }
        });
      }
    },
    // 证件正面照回调
    handleCertificateFrontalPhotoSuccess(res) {
      if (res.code === 200) {
        this.dataForm.certificateFrontalPhoto = res.data.url;
        if (this.requireField('certificateFrontalPhotoJson')) {
          this.$refs['dataForm'].validateField('certificateFrontalPhoto');
        }
      } else {
        this.$message.error(this.$t('personInfo.certFrontUploadFailed'));
      }
    },
    // 证件反面照回调
    handleCertificateReversePhotoSuccess(res) {
      if (res.code === 200) {
        this.dataForm.certificateReversePhoto = res.data.url;
        if (this.requireField('certificateReversePhotoJson')) {
          this.$refs['dataForm'].validateField('certificateReversePhoto');
        }
      } else {
        this.$message.error(this.$t('personInfo.certBackUploadFailed'));
      }
    },
    // 自定义上传1回调
    handleCustomFile1Success(res) {
      if (res.code === 200) {
        this.dataForm.customFile1 = res.data.url;
        if (this.requireField('customFile1Json')) {
          this.$refs['dataForm'].validateField('customFile1');
        }
      } else {
        this.$message.error(this.$t('personInfo.customUploadFailed', { 0: '1' }));
      }
    },
    // 自定义上传2回调
    handleCustomFile2Success(res) {
      if (res.code === 200) {
        this.dataForm.customFile2 = res.data.url;
        if (this.requireField('customFile2Json')) {
          this.$refs['dataForm'].validateField('customFile2');
        }
      } else {
        this.$message.error(this.$t('personInfo.customUploadFailed', { 0: '2' }));
      }
    },
    // 自定义上传3回调
    handleCustomFile3Success(res) {
      if (res.code === 200) {
        this.dataForm.customFile3 = res.data.url;
        if (this.requireField('customFile3Json')) {
          this.$refs['dataForm'].validateField('customFile3');
        }
      } else {
        this.$message.error(this.$t('personInfo.customUploadFailed', { 0: '3' }));
      }
    },
    // 获取职能
    findFunctionList(){
      getFunctionList({type: 1}).then((res) => {
        this.allFunctionOptions = res.data.list;
      });
    },
    // 添加/修改提交
    handleAddEditSubmit(){
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          this.dataForm.teamId = this.teamInfo.id;
          personEdit(this.dataForm).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              this.findPersonList();
              this.btnLoading = false;
              this.formVisible = false;
            } else {
              this.$message.error(res.msg);
              this.btnLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    handleDelete(id){
      this.$confirm(this.$t('personInfo.deleteConfirm'), this.$t('common.prompt'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning",
      }).then(() => {
        let params = {
          ids: id.toString().split(',')
        }
        personDel(params).then(res => {
          if (res.code === 200) {
            this.$message.success(res.msg);
            this.findPersonList();
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
      });
    },
    // 重置
    emptyParams() {
      this.params.realNameCh =  '';
      this.params.gender = '';
      this.params.groupId = '';
      this.params.certificateNumber = '';
      this.params.functionId = '';
      this.params.keyword = '';
      this.findPersonList();
    }
  },
};
</script>
<style scoped lang="scss">
.person-info{
  width: 100%;

  .person-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    margin-bottom: 20px;
    border-bottom: 2px solid #1E50AE;
  }

  .table-center {
    height: calc(100vh - 300px);
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    .table-btn {
      flex-shrink: 0;
      margin-bottom: 10px;
    }

    .table-body {
      flex: 1;
      height: 0;
      min-height: 0;
      overflow: hidden;

      ::v-deep .el-table {
        height: 100%;
      }
    }
  }

  ::v-deep .el-table th {
    background-color: #f0f2f5;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
}


.image-uploader {
  width: 130px;
  height: 130px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.image-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.image {
  width: 130px;
  height: 130px;
  display: block;
}
</style>
